import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

export interface BitrixUserIndividualOffer {
  bitrixUserId: number; // id пользователя
  description: string; // описание индвидуального предложения
  externalId: number; // внешний идентификатор индвидуального предложения
  fileId: string; // id файла КП
  isOrdered: boolean; // заказано ли предложение
  orderedId: number[]; // id заказов в которых было заказано предложение
  price: number; // цена предложения
  title: string; // название предложения
  token: string; // токен предложения
}

export interface LoadBitrixUserIndividualOffersQueryResponse {
  bitrixUserIndividualOffersList: BitrixUserIndividualOffer[];
}

/**
 * Запрос загрузки данных индивидуальных предложений
 */
export class LoadBitrixUserIndividualOffersQuery implements GraphQLQuery<null> {
  readonly query: any;

  readonly variables: null;

  constructor() {
    this.variables = null;
    this.query = gql`
      query __LOAD_USER_INDIVIDUAL_OFFERS__ {
        bitrixUserIndividualOffersList {
          bitrixUserId
          description
          externalId
          fileId
          isOrdered
          orderedId
          price
          title
          token
        }
      }
    `;
  }
}
